<div class="popover" [nbSpinner]="loading()">
  <nb-icon icon="people-outline" pack="eva"></nb-icon>
  <div class="description">
    <div class="title">
      {{region()?.name}} (<span [ngStyle]="{color: region()?.color}">{{region()?.abbreviation}}</span>)
    </div>
    <div class="subtitle">{{region()?.leader?.firstName}} {{region()?.leader?.lastName}} / {{region()?.userCount}} Mitglieder / {{region()?.buildingCount}} Gebäude</div>
  </div>
  <button nbButton size="small" (click)="navigateToDetail()" *ngIf="!disableLink">
    <nb-icon icon="map-outline" pack="eva"></nb-icon>
  </button>
</div>

